import { exigirDefinicionCoherente } from '../formularios/definicion.js';
/**
 * EQ-5D-5L · calidad de vida relacionada con la salud.
 *
 * Cinco dimensiones con nivel 1 a 5 más el termómetro (VAS) de 0 a 100. El dato
 * primario es el **perfil de cinco dígitos** (`21232`) y el VAS; el índice de
 * utilidad es **derivado y recalculable** (ver `crosswalk-eq5d.ts`).
 *
 * **Este formulario queda en `draft` a propósito, y es el único de los cuatro.**
 * El EQ-5D-5L es un instrumento licenciado por EuroQol y la licencia sigue en
 * trámite (Fundación ↔ EuroQol). Sin licencia no se puede incorporar la
 * redacción oficial en español de los niveles —"no tengo problemas para
 * caminar", "tengo problemas leves…"— y **no se inventa una redacción
 * parecida**: un instrumento validado lo es con sus palabras exactas, y un
 * reemplazo casero produciría un puntaje que no es un EQ-5D aunque se le
 * parezca. Los ítems llevan el nombre de la dimensión y su rango, que alcanza
 * para construir la maquinaria y no afirma nada falso.
 *
 * Cuando llegue la licencia: entra la redacción oficial, el formulario pasa a
 * `1.0.0` / `active` y el `Questionnaire` del store se recarga. Nada más cambia.
 *
 * **Baseline en D+120** (mapa de datos validado por Fundación, 2026-08), después
 * cada 60 días hasta D+360. El índice **no lleva color propio**: alcanzan el
 * perfil y el termómetro.
 */
export const DIMENSIONES_EQ5D5L = [
    'movilidad',
    'autocuidado',
    'actividades',
    'dolor',
    'ansiedad',
];
/** Nombre de cada dimensión, en el orden canónico del perfil de cinco dígitos. */
export const NOMBRE_DE_DIMENSION = Object.freeze({
    movilidad: 'Movilidad',
    autocuidado: 'Autocuidado',
    actividades: 'Actividades habituales',
    dolor: 'Dolor o malestar',
    ansiedad: 'Ansiedad o depresión',
});
export const FORMULARIO_EQ5D5L = exigirDefinicionCoherente({
    id: 'eq5d5l',
    clase: 'escala',
    instrumento: 'eq5d5l',
    titulo: 'Cómo te sentís en general',
    // Se queda en 0.1.0 mientras los ítems no lleven la redacción oficial: subir a
    // 1.0.0 con etiquetas genéricas afirmaría que la versión está congelada.
    version: '0.1.0',
    estado: 'draft',
    preguntas: [
        ...DIMENSIONES_EQ5D5L.map((dimension) => ({
            id: dimension,
            texto: `${NOMBRE_DE_DIMENSION[dimension]} · nivel 1 a 5`,
            campo: {
                tipo: 'puntaje',
                minimo: 1,
                maximo: 5,
                // El perfil no es una suma de niveles: se concatenan. Sumarlos daría un
                // número sin significado clínico, así que ninguna dimensión "puntúa".
                puntua: false,
            },
            presentacion: { modo: 'lista' },
            ayuda: 'La redacción oficial de los niveles entra con la licencia de EuroQol.',
            opcional: false,
        })),
        {
            id: 'vas',
            texto: 'Termómetro de estado de salud (0 a 100)',
            campo: {
                tipo: 'puntaje',
                minimo: 0,
                maximo: 100,
                etiquetaMinimo: 'El peor estado de salud que te puedas imaginar',
                etiquetaMaximo: 'El mejor estado de salud que te puedas imaginar',
                puntua: false,
            },
            presentacion: { modo: 'termometro' },
            opcional: false,
        },
    ],
});
//# sourceMappingURL=eq5d5l.js.map